import React from 'react';

export const PlateIcon = props => (
    <span
        style={Object.assign({}, props.style, props.style.display ? { display: props.style.display } : { display: 'block' })}
        dangerouslySetInnerHTML={{
            __html: `
            <?xml version="1.0" encoding="UTF-8" standalone="no"?>
            <!-- Generator: Adobe Illustrator 21.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->

            <svg
                xmlns:dc="http://purl.org/dc/elements/1.1/"
                xmlns:cc="http://creativecommons.org/ns#"
                xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                xmlns:svg="http://www.w3.org/2000/svg"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                version="1.1"
                id="1"
                x="0px"
                y="0px"
                viewBox="0 0 200 440"
                xml:space="preserve"
                inkscape:version="0.48.5 r10040"
                width=${(props.style && props.style.width) ? props.style.width : '100%'}
                height=${(props.style && props.style.height) ? props.style.height : '100%'}
                sodipodi:docname="EU-section-with-GB.svg"
            >
                <metadata
                    id="metadata3107"><rdf:RDF><cc:Work
                     rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type
                    rdf:resource="http://purl.org/dc/dcmitype/StillImage"/></cc:Work></rdf:RDF>
                </metadata>
                <defs id="defs3105"/>
                <sodipodi:namedview
                    pagecolor="#ffffff"
                    bordercolor="#666666"
                    borderopacity="1"
                    objecttolerance="10"
                    gridtolerance="10"
                    guidetolerance="10"
                    inkscape:pageopacity="0"
                    inkscape:pageshadow="2"
                    inkscape:window-width="1015"
                    inkscape:window-height="741"
                    id="namedview3103"
                    showgrid="false"
                    inkscape:zoom="1.2136364"
                    inkscape:cx="0.29962547"
                    inkscape:cy="220"
                    inkscape:window-x="258"
                    inkscape:window-y="23"
                    inkscape:window-maximized="0"
                    inkscape:current-layer="1"/>
                <path
                    class="st0"
                    d="M 0,0 H 200 V 440 H 0"
                    id="path3069"
                    inkscape:connector-curvature="0"
                    style="fill:#003399"/>
                <g id="g3071">
                    <polygon
                        class="st1"
                        points="64.3,191.4 61.5,200 52.8,200 59.8,205 57.1,213.4 64.3,208.2 71.5,213.4 68.7,205 75.8,200 67.1,200 "
                        id="polygon3073"
                        style="fill:#ffcc00"/>
                    <polygon
                        class="st1"
                        points="35.6,103 26.9,103 33.9,108 31.2,116.4 38.4,111.2 45.6,116.4 42.9,108 49.9,103 41.2,103 38.4,94.4 "
                        id="polygon3075"
                        style="fill:#ffcc00"/>
                    <polygon
                        class="st1"
                        points="35.8,151.8 33,143.4 40,138.4 31.4,138.4 28.6,129.8 25.8,138.4 17.1,138.4 24.1,143.4 21.4,151.8 28.6,146.6 "
                        id="polygon3077"
                        style="fill:#ffcc00"/>
                    <polygon
                        class="st1"
                        points="154.4,116.4 161.6,111.2 168.8,116.4 166.1,108 173.1,103 164.4,103 161.6,94.4 158.8,103 150.1,103 157.1,108 "
                        id="polygon3079"
                        style="fill:#ffcc00"/>
                    <polygon
                        class="st1"
                        points="38.4,165.2 35.6,173.7 26.9,173.7 33.9,178.8 31.2,187.2 38.4,182 45.6,187.2 42.9,178.8 49.9,173.7 41.2,173.7 "
                        id="polygon3081"
                        style="fill:#ffcc00"/>
                    <polygon
                        class="st1"
                        points="61.5,76.8 52.8,76.8 59.8,81.8 57.1,90.2 64.3,85 71.5,90.2 68.7,81.8 75.8,76.8 67.1,76.8 64.3,68.2 "
                        id="polygon3083"
                        style="fill:#ffcc00"/>
                    <polygon
                        class="st1"
                        points="97.2,67.3 88.5,67.3 95.5,72.3 92.8,80.7 100,75.5 107.2,80.7 104.5,72.3 111.5,67.3 102.8,67.3 100,58.7 "
                        id="polygon3085"
                        style="fill:#ffcc00"/>
                    <polygon
                        class="st1"
                        points="100,200.9 97.2,209.5 88.5,209.5 95.5,214.5 92.8,222.9 100,217.7 107.2,222.9 104.5,214.5 111.5,209.5 102.8,209.5 "
                        id="polygon3087"
                        style="fill:#ffcc00"/>
                    <polygon
                        class="st1"
                        points="174.2,138.4 171.4,129.8 168.6,138.4 160,138.4 167,143.4 164.2,151.8 171.4,146.6 178.6,151.8 175.9,143.4 182.9,138.4 "
                        id="polygon3089"
                        style="fill:#ffcc00"/>
                    <polygon
                        class="st1"
                        points="161.6,165.2 158.8,173.7 150.1,173.7 157.1,178.8 154.4,187.2 161.6,182 168.8,187.2 166.1,178.8 173.1,173.7 164.4,173.7 "
                        id="polygon3091"
                        style="fill:#ffcc00"/>
                    <polygon
                        class="st1"
                        points="132.9,76.8 124.2,76.8 131.3,81.8 128.5,90.2 135.7,85 142.9,90.2 140.2,81.8 147.2,76.8 138.5,76.8 135.7,68.2 "
                        id="polygon3093"
                        style="fill:#ffcc00"/>
                    <polygon
                        class="st1"
                        points="135.7,191.4 132.9,200 124.2,200 131.3,205 128.5,213.4 135.7,208.2 142.9,213.4 140.2,205 147.2,200 138.5,200 "
                        id="polygon3095"
                        style="fill:#ffcc00"/></g>
                <g id="g3097">
                    <path
                        class="st1"
                        d="m 166.8,316.5 c 0,-16.1 -12.6,-29.1 -28.6,-29.1 h -28.6 v 38.7 19.4 38.7 h 28.2 c 16.1,0 29.1,-13 29.1,-29.1 0,-7.5 -2.7,-14.3 -7.3,-19.5 4.5,-5 7.2,-11.7 7.2,-19.1 z m -29,48.4 h -8.9 v -19.4 h 8.9 c 5.3,0 9.7,4.6 9.7,9.7 0,5.3 -4.5,9.7 -9.7,9.7 z m 0,-38.7 h -8.9 v -19.4 h 8.9 c 5.3,0 9.7,4.6 9.7,9.7 0,5.2 -4.5,9.7 -9.7,9.7 z"
                        id="path3099"
                        inkscape:connector-curvature="0"
                        style="fill:#ffcc00"/>
                    <path
                        class="st1"
                        d="M 61.8,287.4 C 45.7,287.4 33.2,300 33.2,316 v 39.6 c 0,16.1 12.6,28.6 28.6,28.6 16,0 28.6,-12.6 28.6,-28.6 V 331 H 62.1 v 19.4 h 9 v 5.3 c 0,5.3 -4.2,9.3 -9.4,9.3 -5.1,0 -9.1,-4 -9.1,-9.3 v -39.6 c 0,-5.3 4,-9.3 9.1,-9.3 5.3,0 9.4,4 9.4,9.3 v 6.6 h 19.4 v -6.6 C 90.5,300 77.9,287.4 61.8,287.4 z"
                        id="path3101"
                        inkscape:connector-curvature="0"
                        style="fill:#ffcc00"/></g></svg>
            `,
        }}
    />
);



// WEBPACK FOOTER //
// ./src/components/icons/plate-icon.js